import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faEnvelope,
  faMobileScreen,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { colleges } from "../data/colleges";
import { useReveal } from "../lib/motion";
import "./Footer.css";

const MAP_URL =
  "https://www.google.com/maps/dir//Sri+Guru+Arjun+Dev+Ji+Institute+of+Nursing,+HRWW%2B6P7,+Chabbal+Rd,+opp+Radha+swami+dera,+Fatahpur,+Amritsar,+Punjab+143009,+Amritsar,+Punjab+143001,+India/@42.4683088,-83.3896213,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x7093bdb0fc03eef:0x4e791dc2a07f7366!2m2!1d74.8466921!2d31.5955943?entry=ttu&g_ep=EgoyMDI2MDUyMC4wIKXMDSoASAFQAw%3D%3D";

const Footer = () => {
  const [ctaRef, shown] = useReveal();

  return (
    <footer id="site-footer" className="footer">
      <div ref={ctaRef} className={`container footer-cta reveal ${shown ? "is-visible" : ""}`}>
        <div>
          <p className="footer-cta-eyebrow">Admissions for 2026–27 are open</p>
          <h2 className="footer-cta-title">Your seat is waiting</h2>
        </div>
        <a href="/admissions" className="btn btn--primary footer-cta-btn">
          Apply now
          <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </div>

      <div className="container footer-main">
        <div className="footer-brand">
          <p className="footer-wordmark seal-type">
            Sri Guru Arjun Dev Ji
            <span>Group of Institutes</span>
          </p>
          <p className="footer-about">
            Four colleges in Amritsar — nursing, allied healthcare, management
            and law. We're committed to the best learning for our students,
            shaping confident professionals ready to serve their communities.
          </p>
          <div className="footer-socials">
            <a target="_blank" rel="noreferrer" aria-label="Facebook" href="https://www.facebook.com/profile.php?id=61581619677373">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a target="_blank" rel="noreferrer" aria-label="Instagram" href="https://www.instagram.com/guruarjundevgroupofinstitutes/">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a target="_blank" rel="noreferrer" aria-label="WhatsApp" href="https://wa.me/917888570416">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>

        <nav className="footer-col" aria-label="Colleges">
          <h3 className="footer-heading">Colleges</h3>
          {colleges.map((c) => (
            <a
              key={c.slug}
              href={`/colleges/${c.slug}`}
              className="footer-college seal-type"
              style={{ "--accent": `var(--v-${c.slug}-lift)` }}
            >
              {c.name}
              <span className="footer-college-count figures">{c.courses.length}</span>
            </a>
          ))}
        </nav>

        <nav className="footer-col" aria-label="Explore">
          <h3 className="footer-heading">Explore</h3>
          <a href="/home">Home</a>
          <a href="/about-us">Rules &amp; Regulations</a>
          <a href="/facilities">Facilities</a>
          <a href="/admissions">Admissions</a>
          <a href="/careers">Careers</a>
        </nav>

        <div className="footer-col">
          <h3 className="footer-heading">Contact</h3>
          <a href="mailto:shriguruarjundevjiinstitute@gmail.com" className="footer-contact">
            <FontAwesomeIcon icon={faEnvelope} />
            <span>shriguruarjundevjiinstitute@gmail.com</span>
          </a>
          <a href="tel:+919899923387" className="footer-contact">
            <FontAwesomeIcon icon={faMobileScreen} />
            <span>+91-9899923387</span>
          </a>
          <a
            href="https://wa.me/917888570416"
            target="_blank"
            rel="noreferrer"
            className="footer-contact"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
            <span>+91-7888570416</span>
          </a>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">Visit</h3>
          <a href={MAP_URL} target="_blank" rel="noreferrer" className="footer-contact footer-address">
            <FontAwesomeIcon icon={faLocationDot} />
            <span>
              HRWW+6P7, Chabbal Rd, opp Radha Swami Dera, Fatahpur, Amritsar,
              Punjab 143009, India
            </span>
          </a>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>© 2025 Sri Guru Arjun Dev Ji Group of Institutes. All rights reserved.</p>
        <p className="footer-recognition">
          Recognised by INC · PNRC · Guru Nanak Dev University · Baba Farid
          University of Health Sciences · I.K Gujral Punjab Technical University
        </p>
      </div>
    </footer>
  );
};

export default Footer;
